import Vue from 'vue';
import {Model} from '@vuex-orm/core';
import User from "$src/models/userModel";
import Partner from "$src/models/partnerModel";
import DonationBooking from "$src/models/donationBookingModel";
import moment from 'moment';

export default class Donation extends Model {
    static entity = 'donation';
    static primaryKey = 'id_donation';

    static fields() {
        return {
            id_donation: this.number(null),
            id_partner: this.number(null),
            partner: this.belongsTo(Partner, 'id_partner', 'id_partner'),
            id_user: this.attr(null),
            user: this.belongsTo(User, 'id_user', 'id_user'),
            amount_target: this.number(null),
            period_support: this.number(null),
            period_expected_payment: this.attr(null),
            purpose: this.attr(null),
            source: this.attr(null),
            funnel: this.number(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            school_year_start: this.attr(null),
            bookings: this.hasMany(DonationBooking, 'id_donation', 'id_donation'),
            users: this.attr([]),
        };
    }

    get amountCurrent() {
        return this.bookings.reduce((result, booking) => {
            result = result + booking.amount;
            return result;
        }, 0);
    }

    get periodSupportString() {
        if (this.period_support  > 0) {
            let plural = this.period_support > 1 ? 'e' : '';
            return `${this.period_support} Jahr${plural}`;
        } else {
            return null;
        }

    }

    get funnelString() {
        return Vue.__(`partner_donation_funnel/${this.funnel}`);
    }

    get schoolYearStartString() {
        return Vue.__(`school_year/${this.school_year.start}`);
    }

    get lastBooking() {
        if (this.bookings.length == 0) {
            return null;
        } else if (this.bookings.length == 1) {
            return this.bookings[0].entry_at;
        }
        return this.bookings.reduce(function(prev, current) {
            return (prev.entry_at > current.entry_at) ? prev.entry_at : current.entry_at;
        });
    }

    get createdDateString() {
        return moment(this.created_at).format("D.MM.YYYY");
    }

    get updatedDateString() {
        return moment(this.updated_at).format("D.MM.YYYY");
    }

    static periodSupportSelect() {
        return [
            {key: 1, label: '1 Jahr'},
            {key: 2, label: '2 Jahre'},
            {key: 3, label: '3 Jahre'},
            {key: 4, label: '4 Jahre'},
            {key: 5, label: '5 Jahre'},
        ];
    }
}